import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GcvAdminApi } from 'api';
import { SFTP_SALES_PROVIDER_KEY, SFTP_SALES_PROVIDERS_KEY } from 'tanstack-hooks/keys';

export function useRemoveSftpSalesLocationMapping(providerId: string) {
  const gcvAdminApi = new GcvAdminApi();
  const queryClient = useQueryClient();

  const { mutateAsync: removeSftpSalesLocationMapping, isPending: isRemovingSftpSalesLocationMapping } =
    useMutation({
      mutationKey: [SFTP_SALES_PROVIDER_KEY, providerId, 'removeLocationMapping'],
      mutationFn: (locationId: string) => gcvAdminApi.removeSftpSalesLocationMapping(providerId, locationId),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [SFTP_SALES_PROVIDERS_KEY] });
        queryClient.invalidateQueries({ queryKey: [SFTP_SALES_PROVIDER_KEY, providerId] });
      },
      meta: {
        snackbarSuccessMessage: 'Location mapping removed successfully.',
        snackbarErrorMessage: 'There was an issue removing the location mapping. Please try again.'
      }
    });

  return { removeSftpSalesLocationMapping, isRemovingSftpSalesLocationMapping };
}
